import { Stack, Text, Title } from '@mantine/core';
import { StockList } from './StockList';

export function TickersPage() {
  return (
    <Stack gap="md" py="md">
      <Stack gap={4}>
        <Title order={2} size="h4">
          Top NYSE companies by market cap
        </Title>
        <Text c="dimmed" size="sm">
          Prices refresh during market hours · Buzz Score updates every 15 min · Not financial advice.
        </Text>
      </Stack>
      <StockList />
    </Stack>
  );
}
